/**
 * Module definition for widgets module. The widgets module manages
 * the application's top-level widgets view (i.e., /widgets).
 *
 * @module routes.cases.widgets
 */

angular.module('routes.cases.widgets', [
  'stack',
  'routes.cases.widgets.constants',
  'routes.cases.widgets.WidgetsController',
  'routes.cases.widgets.WidgetsPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.cases.states.widgets', {
          url: '/widgets/:widgetId?:widgetMode',
          templateUrl: 'routes/cases/widgets/widgets.html',
          controller: 'WidgetsController',
          params: {
            widgetId: {
              value: null,
              squash: true
            },
            widgetMode: {
              value: null,
              squash: true
            }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'WIDGETS',
              function (ConstantResolver, WIDGETS) {
                return new ConstantResolver(WIDGETS);
              }
            ],
            widgetsPayload: [
              'WidgetsPayloadResolver',
              '$stateParams',
              'casesPayload',
              function (WidgetsPayloadResolver, $stateParams, casesPayload) {
                return new WidgetsPayloadResolver($stateParams, casesPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
